import { ZINDEX_LEVELS } from "../Helpers/Enums";

const Loader = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        zIndex: ZINDEX_LEVELS.LEVEL_1,
        backgroundColor: "#fffefe63",
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        style={{
          width: "15rem",
        }}
        src="assets/images/seafarer-loader.gif"
        alt="Loader"
      />
    </div>
  );
};

export default Loader;

export const SimpleLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <img
        style={{
          width: "15rem",
          flexGrow: 1,
        }}
        src="assets/images/seafarer-loader.gif"
        alt="Loader"
      />
    </div>
  );
};
